import React from "react";
import SubscribeInput from "@/src/components/custom/SubscribeInput";

function Subscribe() {
  return (
    <div className="border-b border-white/10">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">
            Stay Updated with B2B Technology Insights
          </h3>
          <p className="text-white/80 mb-6">
            Get weekly updates on the latest technology reviews, industry news,
            and expert insights delivered to your inbox.
          </p>
          <SubscribeInput variant="dark" />
          <p className="text-xs text-white/60 mt-3">
            No spam. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Subscribe;
